export const CONSTANTS = {
	fallbackImageUrl:
		'https://media-api.xogrp.com/images/54de075e-7a99-4211-83a2-635901ab56e4',
	imageMargin: 8,
	mobileImagesToShow: 4,
	mobile: {
		imageHeight: 80,
		imageWidth: 80,
	},
	desktop: {
		imageHeight: 80,
		imageWidth: 80,
	},
};
